import { creditInformationFeature } from './credit-information.reducer';

const { selectCreditInformation } = creditInformationFeature;

export const CreditInformationSelectors = {
  selectCreditInformation,
};
